import React, { useState, useEffect } from "react";
import { cashOutFoodApi, getAcountinListApi, getWalletApi } from "../../Api/DeliveryBarest";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import { separate } from "../../Functions/NumberSeprator";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import moment from "jalali-moment";
import Style from './WalletPage.module.css'
const WalletPage = () => {
  const [data, setData] = useState([]);
  const [amountWallet, setAmountWallet] = useState([]);
  const [filter, setFilter] = useState(0);
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    getAcountingInfo();
    getWallet();
  }, []);
//////////لیست ریز تراکنش ها ////////////////
  const getAcountingInfo = async () => {
    const result = await getAcountinListApi();
    result.transactions.sort((a, b) => {
      if (a.id > b.id) {
        return -1;
      } else {
        return 1
      };
    })
    setData(result.transactions);
  };
  //////////////گرفتن موجودی کیف پول //////////////////
  const getWallet = async () => {
    const result = await getWalletApi();
    setAmountWallet(result.wallet);
  };
  ////////// هندل کردن قسمت فیلتر واریزی و برداشتی ////////////////
  const SetFilterOnAmountList = (id) => {
    if (id === 0) {
      setFilter(0);
    } else if (id === 1) {
      setFilter(1);
    } else if (id === 2) {
      setFilter(2);
    }
  };
  ///////////درخواست برداشت //////////////////
  const requestCash=()=>{
    setDisable(true)
    let info={
      cashout:true
    }
    cashOutFoodApi(info,res=>{
      if(res.status===1){
        setDisable(false)
        succToast(res.message)
      }else{
        setDisable(false)
        errorToast(res.message)
      }
      getWallet()
    })
  }
  return (
    <div className={Style.pageHolder}>
      <MenuTitle title={"حسابداری"} />
      <div className={Style.center}>
        <div className={Style.amountAcountPart}>
            <div className={Style.amountAcount}>
                موجودی حساب:<span className={Style.price}>{amountWallet?separate(amountWallet):0} تومان </span>
            </div>
            <button disabled={disable} onClick={requestCash} className={Style.btnGet}>برداشت</button>
        </div>
        <div className={Style.filterPart}>
          <div
            className={filter===0?Style.eachFilterSelect:Style.eachFilter}
            onClick={() => SetFilterOnAmountList(0)}
          >
            همه
          </div>
          <div
            className={filter===1?Style.eachFilterSelect:Style.eachFilter}
            onClick={() => SetFilterOnAmountList(1)}
          >
            واریزی ها
          </div>
          <div
            className={filter===2?Style.eachFilterSelect:Style.eachFilter}
            onClick={() => SetFilterOnAmountList(2)}
          >
            برداشتی ها
          </div>
        </div>
        <div className={Style.holder}>
          {data.filter((value)=>{
            if(filter===2){
                return value.amount<0
            }else if (filter===1){
                return value.amount>0
            }else if(filter===0){
                return value
            } else return false
          }).map((item, index) => {
            return (
              <div
              key={index}
              className={
                item.amount < 0 ? Style.eachItemOut : Style.eachItemIn
              }
            >
              <h2 style={{ fontSize: ".7rem" }}>
                {" "}
                شماره تراکنش:{" "}
                <span className={Style.details}>{separate(item.id)} </span>
              </h2>
              {
                item.track_id?<h2 style={{ fontSize: ".7rem" }}>
                {" "}
                 کد پیگیری :{" "}
                <span className={Style.details}>{item.track_id} </span>
              </h2>:null
              }
              {item.amount > 0 ? (
                <h2 style={{ fontSize: ".7rem" }}>
                  {" "}
                  شماره سفارش:{" "}
                  <span className={Style.details}>
                    {separate(item.order_id)}{" "}
                  </span>
                </h2>
              ) : null}
              {item.amount < 0 ? (
                <h2 style={{ fontSize: ".7rem" }}>
                  {" "}
                  کارمزد:{" "}
                  <span className={Style.details}>
                    {separate(item.wage)}{" "}
                  </span>
                </h2>
              ) : null}
              <h2 style={{ fontSize: ".7rem" }}>
                مقدار:{" "}
                <span className={Style.details}>
                  {separate(item.amount)}{" "}
                </span>
                تومان
              </h2>
              <h2 style={{ fontSize: ".7rem" }}>
                تاریخ :{" "}
                <span className={Style.details}>
                  {separate(item.date)}{" "}
                </span>
              </h2>
                {
                  item.withdraw_date?                  <h2 style={{ fontSize: ".7rem" }}>
                  تاریخ واریز :{" "}
                  <span className={Style.details}>
                    {moment.unix(item.withdraw_date).format('YYYY/MM/DD HH:MM')}{" "}
                  </span>
                </h2>:null
                }

            </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WalletPage;
